import { render, staticRenderFns } from "./SingleMLModal.vue?vue&type=template&id=04bdaa70&scoped=true&"
import script from "./SingleMLModal.vue?vue&type=script&lang=ts&"
export * from "./SingleMLModal.vue?vue&type=script&lang=ts&"
import style0 from "./SingleMLModal.vue?vue&type=style&index=0&id=04bdaa70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bdaa70",
  null
  
)

export default component.exports